import { lazy } from 'react';
import { BRANCH_ADMIN_ROUTES } from '../path';
import RouteTypes from '../route_types';
// Common Components
const CommonLayout = lazy(() => import('../../../voim/component/common/Layout'));
const NotFound = lazy(() => import('../../../voim/component/common/NotFound'));
const ChangePassword = lazy(() => import('../../../voim/component/common/ChangePassword'));
// Level Two Components
// Dashboard
const Dashboard = lazy(() => import('../../../voim/component/admin/branch-admin/dashboard'));
// Educator
const TutorsList = lazy(
    () => import('../../../voim/component/admin/branch-admin/tutor/TutorsList')
);
const AddTutor = lazy(() => import('../../../voim/component/admin/branch-admin/tutor/AddTutor'));
const ViewTutor = lazy(() => import('../../../voim/component/admin/branch-admin/tutor/ViewTutor'));
const TutorBatchUpload = lazy(
    () => import('../../../voim/component/admin/branch-admin/tutor/TutorBatchUpload')
);
// Student
const StudentList = lazy(
    () => import('../../../voim/component/admin/branch-admin/student/StudentList')
);
const AddStudent = lazy(
    () => import('../../../voim/component/admin/branch-admin/student/AddStudent')
);
const ViewStudent = lazy(
    () => import('../../../voim/component/admin/branch-admin/student/ViewStudent')
);
const StudentBatchUpload = lazy(
    () => import('../../../voim/component/admin/branch-admin/student/StudentBatchUpload')
);
const AddNotes = lazy(() => import('../../../voim/component/common/AddNotes'));
// Subject
// const SubjectList = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/subject/SubjectList")
// );
// const AddSubject = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/subject/AddSubject")
// );
// const ViewSubject = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/subject/ViewSubject")
// );
// Sub Category
// const SubCategoryList = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/sub-category/SubCategoryList")
// );
// const AddSubCategory = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/sub-category/AddSubCategory")
// );
// const ViewSubCategory = lazy(() =>
//   import("../../../voim/component/admin/branch-admin/sub-category/ViewSubCategory")
// );
// Session
const SessionList = lazy(
    () => import('../../../voim/component/admin/branch-admin/session/SessionList')
);
const createSession = lazy(
    () => import('../../../voim/component/admin/branch-admin/session/createSession')
);
const SessionSummary = lazy(
    () => import('../../../voim/component/admin/branch-admin/session/SessionSummary')
);
// Request
const CancelRequestList = lazy(
    () => import('../../../voim/component/admin/branch-admin/request/CancelRequestList')
);
// Financial Report
const FinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/FinancialReport')
);
const CustomFinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/CustomFinancialReport')
);
const PayoutReport = lazy(() => import('./../../../voim/component/common/Reports/PayoutReport'));
const LevelWiseReport = lazy(() => import('./../../../voim/component/common/LevelWiseReport'));
export default [
    // Dashboard
    {
        path: BRANCH_ADMIN_ROUTES.DASHBOARD,
        component: CommonLayout,
        pageComponent: Dashboard,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: true,
        active: 'dashboard',
        levelTitle: 'Level 3',
        icon: 'material-icons',
    },
    {
        path: BRANCH_ADMIN_ROUTES.LEVEL_WISE_REPORT,
        component: CommonLayout,
        pageComponent: LevelWiseReport,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: false,
        levelTitle: 'Level 3',
    },
    // Educator
    {
        path: BRANCH_ADMIN_ROUTES.TUTORLIST,
        component: CommonLayout,
        pageComponent: TutorsList,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Educators',
        showNavigation: true,
        navMenu: true,
        active: 'educators',
        levelTitle: 'Level 3',
        icon: 'fas fa-user-circle',
    },
    {
        path: BRANCH_ADMIN_ROUTES.ADD_TUTOR,
        component: CommonLayout,
        pageComponent: AddTutor,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Add Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.EDITTUTOR,
        component: CommonLayout,
        pageComponent: AddTutor,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Edit Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.TUTOR,
        component: CommonLayout,
        pageComponent: ViewTutor,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'View Educator',
        showNavigation: true,
        navMenu: false,
        active: 'educators',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.TUTOR_BATCH,
        component: CommonLayout,
        pageComponent: TutorBatchUpload,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Upload Educators',
        showNavigation: true,
        navMenu: false,
        active: 'tutors',
        levelTitle: 'Level 3',
    },
    // Student
    {
        path: BRANCH_ADMIN_ROUTES.STUDENTLIST,
        component: CommonLayout,
        pageComponent: StudentList,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Students',
        showNavigation: true,
        navMenu: true,
        active: 'students',
        levelTitle: 'Level 3',
        icon: 'fas fa-user-graduate',
    },
    {
        path: BRANCH_ADMIN_ROUTES.ADD_STUDENT,
        component: CommonLayout,
        pageComponent: AddStudent,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Add Student',
        showNavigation: true,
        navMenu: false,
        active: 'students',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.STUDENT,
        component: CommonLayout,
        pageComponent: ViewStudent,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'View Student',
        showNavigation: true,
        navMenu: false,
        active: 'students',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.EDITSTUDENT,
        component: CommonLayout,
        pageComponent: AddStudent,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Edit Student',
        showNavigation: true,
        navMenu: false,
        active: 'students',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.STUDENT_BATCH,
        component: CommonLayout,
        pageComponent: StudentBatchUpload,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Upload Students',
        showNavigation: true,
        navMenu: false,
        active: 'students',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.ADD_NOTES,
        component: CommonLayout,
        pageComponent: AddNotes,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Add Notes',
        showNavigation: true,
        navMenu: false,
        active: 'students',
        levelTitle: 'Level 3',
    },
    // Subject
    // {
    //   path: BRANCH_ADMIN_ROUTES.SUBJECTLIST,
    //   component: CommonLayout,
    //   pageComponent: SubjectList,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'Subjects',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'subjects',
    //   levelTitle: 'Level 3',
    //   icon: 'fa fa-file',
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.ADD_SUBJECT,
    //   component: CommonLayout,
    //   pageComponent: AddSubject,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'Add Subject',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'subjects',
    //   levelTitle: 'Level 3'
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.EDIT_SUBJECT,
    //   component: CommonLayout,
    //   pageComponent: AddSubject,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'Edit Subject',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'subjects',
    //   levelTitle: 'Level 3'
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.SUBJECT,
    //   component: CommonLayout,
    //   pageComponent: ViewSubject,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'View Subject',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'subjects',
    //   levelTitle: 'Level 3'
    // },
    // SubCategory
    // {
    //   path: BRANCH_ADMIN_ROUTES.SUB_CATEGORY_LIST,
    //   component: CommonLayout,
    //   pageComponent: SubCategoryList,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'Sub Category',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'sub-categories',
    //   levelTitle: 'Level 3',
    //   icon: 'fa fa-file-text'
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.ADD_SUBCATEGORY,
    //   component: CommonLayout,
    //   pageComponent: AddSubCategory,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'Add Sub Category',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'sub-categories',
    //   levelTitle: 'Level 3'
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.EDIT_SUBCATEGORY,
    //   component: CommonLayout,
    //   pageComponent: AddSubCategory,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'edit Subcategory',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'sub-categories',
    //   levelTitle: 'Level 3'
    // },
    // {
    //   path: BRANCH_ADMIN_ROUTES.SUBCATEGORY,
    //   component: CommonLayout,
    //   pageComponent: ViewSubCategory,
    //   roleType: RouteTypes.BRANCH_ADMIN,
    //   title: 'View Sub Category',
    //   showNavigation: true,
    //   navMenu: false,
    //   active: 'sub-categories',
    //   levelTitle: 'Level 3'
    // },
    // Session
    {
        path: BRANCH_ADMIN_ROUTES.SESSIONS_LIST,
        component: CommonLayout,
        pageComponent: SessionList,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Sessions',
        showNavigation: true,
        navMenu: true,
        active: 'sessions',
        levelTitle: 'Level 3',
        icon: 'fa fa-calendar',
    },
    {
        path: BRANCH_ADMIN_ROUTES.CREATE_SESSION,
        component: CommonLayout,
        pageComponent: createSession,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Create Session',
        showNavigation: true,
        navMenu: false,
        active: 'sessions',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.SESSION_SUMMARY,
        component: CommonLayout,
        pageComponent: SessionSummary,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Session Summary',
        showNavigation: true,
        navMenu: false,
        active: 'sessions',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.CANCEL_REQUEST_LIST,
        component: CommonLayout,
        pageComponent: CancelRequestList,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Requests',
        showNavigation: true,
        navMenu: false,
        active: 'cancel-request',
        levelTitle: 'Level 3',
        icon: 'fa fa-calendar',
    },
    // Financial Report
    {
        path: BRANCH_ADMIN_ROUTES.FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: FinancialReport,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: true,
        active: 'financial-reports',
        levelTitle: 'Level 3',
        icon: 'fa-solid fa-money-bill-wave',
    },
    {
        path: BRANCH_ADMIN_ROUTES.CUSTOM_FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: CustomFinancialReport,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 3',
    },
    {
        path: BRANCH_ADMIN_ROUTES.PAYOUT_REPORT,
        component: CommonLayout,
        pageComponent: PayoutReport,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 3',
    },
    // Common
    {
        path: BRANCH_ADMIN_ROUTES.CHANGE_PASSWORD,
        component: CommonLayout,
        pageComponent: ChangePassword,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Change Password',
        showNavigation: false,
        navMenu: false,
        active: 'Change Password',
        levelTitle: 'Level 3',
    },
    {
        path: '*',
        component: NotFound,
        roleType: RouteTypes.BRANCH_ADMIN,
        title: 'Not Found',
        active: 'Not Found',
        levelTitle: 'Level 3',
    },
];
